var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('label', {
    staticClass: "field__label",
    class: _vm.subject.required === true ? 'field--required' : null,
    attrs: {
      "id": _vm.subject.id
    }
  }, [_vm._v(" " + _vm._s(_vm.subject.title) + " ")]), _vm._t("default"), _vm.subject.memo ? _c('small', {
    staticClass: "field__desc"
  }, [_vm._v(" " + _vm._s(_vm.subject.memo) + " ")]) : _vm._e(), _vm.validateError ? _c('div', {
    staticClass: "error_msg"
  }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")]) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }